export default __webpack_public_path__ + "static/media/192128f03fe8f709db0b27c758782b7f1581617591910.3c8ff8fd.webp";